import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'zest-order-banner',
  templateUrl: './order-banner.component.html',
  styleUrls: ['./order-banner.component.scss']
})
export class OrderBannerComponent implements OnInit {

  @Input() showOrderBanner: boolean;
  @Input() message: string;
  @Input() showMerchantLogo: boolean;
  @Input() merchantName: string;
  @Input() basketAmount: number;
  @Input() emi: number;

  public s3BucketUrl: string;

  constructor() { }

  ngOnInit() {
    this.s3BucketUrl = environment.s3BucketUrl;
  }

}
